import * as React from "react"
const SvgSecurity = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10.95 13.414-1.4-1.4a.96.96 0 0 0-.7-.3q-.4 0-.7.3t-.3.713.3.712l2.1 2.125q.3.3.7.3t.7-.3l4.25-4.25q.3-.3.3-.712 0-.413-.3-.713t-.713-.3q-.411 0-.712.3zm1.05 9.2a2 2 0 0 1-.625-.1Q8 21.389 6 18.352t-2-6.538V7.09q0-.624.362-1.125.363-.5.938-.725l6-2.25a2.1 2.1 0 0 1 .7-.125q.35 0 .7.125l6 2.25q.575.225.938.725Q20 6.466 20 7.09v4.725q0 3.5-2 6.538-2 3.037-5.375 4.162a2 2 0 0 1-.625.1Zm0-2q2.6-.825 4.3-3.3c1.7-2.475 1.7-3.483 1.7-5.5V7.09l-6-2.25-6 2.25v4.725q0 3.025 1.7 5.5c1.7 2.475 2.567 2.75 4.3 3.3Z" />
  </svg>
)
export default SvgSecurity
